export enum VrGoggleStatus {
    Enabled = 0,
    Disabled = 1
}

export interface IVrGoggleModel {
    id: string;
    externalDeviceId: string;
    displayName: string;
    status: VrGoggleStatus;
    registeredAt: string;
    isConnected: boolean;
    lastSeenUserId: string | null;
}
